<template lang="html">
    <simple-layout
        :models-loaded="true"
        imgCover
        img="/static/img/static_img_viveco.jpg"
        imgPosY="-300"
        :indicators="[
            {
                title: $store.getters.clientsCount,
                subtitle: 'Clients'
            },
            {
                title: $store.getters.simulationsCount,
                subtitle: 'Simulations'
            },
        ]"
    >
        <div class="main-container">
            <div class="headline">
                <h1>Grilles tarifaires</h1>
                <el-button type="primary" @click="createPriceList">Créer une grille</el-button>
            </div>
            <ns-loader
                ref="pricingListLoader"
                :toLoad="toLoad"
                class="imputation-ns-paginate"
                @dataFetched="onDataFetched"
            >
                <template slot="content">

                    <el-row :gutter="20" v-if="priceLists.length">
                        <el-col
                            v-for="(list, index) in priceLists"
                            :xl="6"
                            :lg="8"
                            :md="12"
                            :sm="12"
                            :xs="24"
                            :key="index"
                        >
                            <Pricing
                                :list="list"
                                @changePricingGrid="changePricingGrid"
                            ></Pricing>
                        </el-col>
                    </el-row>
                    <div v-else>Aucune grille tarifaire n'existe</div>
                </template>
                <div slot="error">Aucune grille tarifaire n'existe, veuillez en créer une ou contacter un administrateur</div>
            </ns-loader>
        </div>
        <PricingModal
            :showModal="showModal"
            :chosenPricingGrid="chosenPricingGrid"
            :key="showModal"
            @closeModal="closeModal"
            @refreshLoader="refreshLoader"
        ></PricingModal>
    </simple-layout>
</template>

<script>

import Pricing from '../../Pricing/index.vue';
import PricingModal from '../../Pricing/pricingModal.vue';
import nsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';

export default {
    components: {
        Pricing,
        PricingModal,
        nsLoader
    },
    created(){
        console.log('Home')
    },
    data () {
        return {
            showModal: false,
            chosenPricingGrid: null,
            emptyList: {
                name: '',
                in_use: true,
                values: [
                    {
                        min: 1,
                        max: 10,
                        price: 10
                    },
                    {
                        min: 11,
                        max: null,
                        price: 20
                    },
                ]
            },
            priceLists: [],
        };
    },
    computed: {
        toLoad() {
            return [
                {
                    model: 'priceLists',
                    name: 'priceLists',
                }
            ];
        }
    },
    methods: {
        onDataFetched(resp) {
            this.priceLists = resp.priceLists;
        },
        createPriceList() {
            this.chosenPricingGrid = null;
            this.showModal = true;
        },
        changePricingGrid(grid) {
            this.$set(this, 'chosenPricingGrid', grid);
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.$refs.pricingListLoader.triggerRefresh();
        },
        refreshLoader() {
            this.closeModal();
        }
    }
};
</script>

<style lang="scss">
.main-container {
    padding: 0 20px;
    .headline {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/index.vue